import { useState } from "react";
import "../assets/styles/Cricket.css";
import Menu_select from "../components/Menu_select";
import Menu_Middle from "../components/Menu_Middle";
import Bet_slip from "../components/Bet_slip";
import { useSelector } from "react-redux";
import HighlightsHeader from "../components/highlights-header";


const Cricket = () => {

  const [loading, setLoading] = useState(false);

  const { matches: cricketMatches } = useSelector(
    (state) => state.matches.cricket
  );
  

  return (
    <>
      <div className="Cricket-wrap">
        <Menu_select menuItems={cricketMatches.data} />
         <Menu_Middle cricketMatches={cricketMatches} MatchName={"Cricket"} loader={loading}/>
        <Bet_slip />
      </div>
    </>
  );
};

export default Cricket;
